import { faker } from '@faker-js/faker';

import type { MarketingPreferencesPostResponse } from '../types/MarketingPreferencesPostResponse';

export function createMarketingPreferencesPostResponse(
  data: NonNullable<Partial<MarketingPreferencesPostResponse>> = {}
): NonNullable<MarketingPreferencesPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
